import { Modal } from '@gerdau/hefesto';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FooterBoxLink } from '../../pages/NewHelpCenter/HelpCenterFooter/styles';
import { EOrdersRoutes } from '../../pages/Orders/orders.routes';
import { ApplicationState } from '../../store';
import { setShowCommerceTokenModal } from '../../store/ducks/auth/actions';
import { GetFlag } from '../../utils/featureFlag';

const CommerceTokenUnavailableModal: React.FC = () => {
  const dispatch = useDispatch();

  const tryAgainRoute = useSelector(
    (appState: ApplicationState) => appState.auth.tryAgainRoute
  );

  const commerceTokenModalFlag = GetFlag('commerce_token_modal');

  const close = (): void => {
    dispatch(setShowCommerceTokenModal(false));
    if (!tryAgainRoute) {
      window.location.href = `/purchase/commerce/${EOrdersRoutes.STEEL_TYPE_CHOOSE}`;
    }
  };

  const tryAgain = (): void => {
    if (tryAgainRoute) {
      window.location.href = tryAgainRoute;
    } else {
      window.location.reload();
    }
  };

  return !commerceTokenModalFlag ? (
    <span />
  ) : (
    <Modal
      title="Comprar aços longos está temporariamente indisponível"
      onClose={close}
      buttons={{
        left: {
          children: 'Fechar',
          name: 'fechar',
          onClick: close,
          type: 'button'
        },
        right: {
          children: 'Tentar novamente',
          name: 'tentar-novamente',
          onClick: tryAgain,
          type: 'button'
        }
      }}
      modalSize="sm"
    >
      <div>
        Isto pode acontecer devido a instabilidades temporárias no sistema, no
        navegador ou na conexão. Você pode:
      </div>
      <div style={{ marginTop: '20px' }}>
        <ul>
          <li>—&nbsp;Verificar se há conexão com a internet.</li>
          <li>—&nbsp;Deslogar e logar novamente na Gerdau mais.</li>
          <li>—&nbsp;Fechar e abrir seu navegador novamente.</li>
        </ul>
      </div>
      <div>
        Caso o problema persista, solicite suporte pelo telefone{' '}
        <b>0800 722 3322</b> ou pelo email{' '}
        <FooterBoxLink href="mailto:Suporte Gerdau mais<suportegerdaumais@gerdau.com.br>">
          suportegerdaumais@gerdau.com.br
        </FooterBoxLink>
        .
      </div>
    </Modal>
  );
};

export default CommerceTokenUnavailableModal;
